import router from './router'
import store from './store'
import NProgress from 'nprogress' // 进度条
import 'nprogress/nprogress.css'// progress bar style
import { getToken } from '@/utils/auth' // getToken from cookie
import { Loading } from 'element-ui'

NProgress.configure({ showSpinner: false })// NProgress Configuration
const whiteList = ['/login', '/404']// no redirect whitelist
router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (getToken()) { // determine if there has token
    /* has token */
    if (to.path === '/login') {
      // 下一个路由
      next({ path: '/home' })
      NProgress.done()
    } else {
      if (!store.getters.addRouters.length) { // 判断当前用户是否已拉取完user_info信息
        let loading = ''
        loading = Loading.service({
          lock: true,
          text: '数据加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.0)'
        })
        store.dispatch('GetInfo').then(() => {
          loading.close()
          next({ ...to })
        })
      } else {
        next()
      }
    }
  } else {
    /* has no token */
    if (whiteList.indexOf(to.path) !== -1) { // 免登录白名单
      next()
    } else {
      next('/login') // 否则全部重定向到web登录页
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})
router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js